import CustomButton from "components/Atoms/CustomButton"
import { withFormController } from "components/Molecules/FormController"
import React, { useMemo } from "react"
import { inr } from "utils/formatters.utils"
import { getAvailableStock } from "./OrderItem"
import useOrderIds from "./useOrderIds"

const OrderFooter = ({ disabled, onAdd, source, showDiscount = false }) => {
  const orderItems = source?.orderItems
  const orders = useOrderIds()
  const isConsolidated = orders?.length > 0
  const { amount, quantity, stock } = useMemo(
    () =>
      orderItems?.reduce(
        (p, i) => {
          const stock = i?.sellableItemStock
          return {
            amount: p.amount + (stock?.discountedRate || 0) * i?.quantity || 0,
            quantity: p.quantity + i.quantity,
            stock: p.stock + getAvailableStock(stock, isConsolidated),
          }
        },
        { amount: 0, quantity: 0, stock: 0 }
      ) ?? {},
    [orderItems, isConsolidated]
  )

  return (
    <div className="grid grid-cols-12">
      {/* <div></div> */}
      <div className="col-span-3">
        <CustomButton
          disabled={disabled}
          onClick={e => onAdd("orderItems", { quantity: "" })}
          intent="success"
          icon="plus"
          text="Add Item"
          fill
          big
          data-testid="add-item-buttom"
        />
      </div>
      {orders?.length > 0 && <div></div>}
      <div></div>
      <div data-testid="total-quantity-text" className="col-span-2">
        {quantity} <small>Units</small>
      </div>
      <div data-testid="total-cost-text">{inr(amount)}</div>
      {showDiscount && (
        <>
          <div></div>
          <div></div>
        </>
      )}
      <div data-testid="total-stock-text">
        {stock || 0} <small>Units</small>
      </div>
      <div></div>
    </div>
  )
}

export default withFormController(OrderFooter)
